import { Point, Texture } from "pixi.js";
import { SocialCommunitiesResourcePackage } from "../../resources/SocialCommunitiesResourcePackage";

export class SocialItemsConfig {
    public readonly itemsDescription: Array<SocialItemDescription>;

    public constructor(socialResources: SocialCommunitiesResourcePackage) {
        this.itemsDescription = new Array<SocialItemDescription>(
            { position: new Point(0, 0), iconTexture: socialResources.assets_views_social_communities_icons_diskord_png, text: "DISCORD", redirectUrl: "https://discord.com/invite/cityversetycoon" },
            { position: new Point(250, 0), iconTexture: socialResources.assets_views_social_communities_icons_x_png, text: "X", redirectUrl: "https://twitter.com/CityVerseTycoon" },
            { position: new Point(0, 300), iconTexture: socialResources.assets_views_social_communities_icons_facebook_png, text: "FACEBOOK", redirectUrl: "https://www.facebook.com/profile.php?id=100090370982080" },
            { position: new Point(250, 300), iconTexture: socialResources.assets_views_social_communities_icons_Instagram_png, text: "INSTAGRAM", redirectUrl: "https://www.instagram.com/cityverse_tycoon" },
            { position: new Point(0, 600), iconTexture: socialResources.assets_views_social_communities_icons_tik_tok_png, text: "TIKTOK", redirectUrl: "https://www.tiktok.com/@cityverse.tycoon" }
        )
    }
}

type SocialItemDescription = {
    position: Point;
    iconTexture: Texture;
    text: string;
    redirectUrl: string;
}
